<template>
  <div v-if="invite">
    <div class="centered-column">
      <div class="container-header">
        <button
            class="back-btn"
            @click="goBack"
        >
          <i class="atto atto-ldir-arrow-b"/>
        </button>
        <h3>{{ invite.email }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('account') }}</label>
          </div>
        </div>
        <div class="user-details">
          <div
              class="user-profile"
          >
            <div class="profile-pic">
              <i class="atto atto-avatar" />
             <!-- <span class="initials" />-->
              <img
                  :alt="invite.name"
                  v-if="invite.avatar"
                  :src="invite.avatar"
                  width="100"
                  height="100"
              />
            </div>
            <div class="user-info">
              <div class="name info-field">
                <span class="mail">{{ invite.email }}</span>
              </div>
              <hr class="separator-line">
              <div class="mail info-field">
                <span class="joined-date">{{ label.get('request_pending') }}</span>
                <span class="error invite-info">{{ label.get('invite_request_pending_description') }}</span>
              </div>
            </div>
          </div>
          <div class="role-and-department">
            <div class="wrapper">
              <span class="label-wrap">
                 <i class="atto atto-rdir-arrow-b"/>
                {{ label.get('member_role')}}
              </span>
              <select-dropdown-component
                  :value="invite.role_id"
                  :options="roles"
                  @onOptionSelected="onRoleChanged"
              />
            </div>
            <div class="wrapper mb-0" v-if="departmentEnabled">
              <span class="label-wrap">
                 <i class="atto atto-rdir-arrow-b"/>
                {{ label.get('department') }}
              </span>
              <select-dropdown-component
                  :value="department"
                  :options="departments"
                  @onOptionSelected="onDepartmentChanged"
              />
            </div>
          </div>
        </div>
        <div class="invite-profile invite-buttons">
          <button class="atto-btn submit lg-btn"
                  @click="resendInvite"
                  :disabled="resendButtonDisabled"
          >{{ label.get('resend_invite') }}
          </button>
          <button class="atto-btn deactivate lg-btn"
                  @click="deleteInvite(invite)"
          >
            {{ label.get('remove_pending_request') }}
          </button>
        </div>
      </div>
      <delete-member-component
          v-if="deleteItem"
          :id="itemId"
          :type="itemType"
          />
    </div>
  </div>
</template>

<script>
  import MemberService from "../services/MemberService";
  import InviteService from "../../../../shared/services/InviteService";
  import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
  import DeleteMemberComponent from "./DeleteMemberComponent";

  export default {
   name: "InviteProfileComponent",
    components: {DeleteMemberComponent, SelectDropdownComponent},
    data () {
       return {
        invite: null,
        roles: [
        {
          value: 1,
          label: this.label.get('admin')
        },
        {
          value: 2,
          label: this.label.get('manager')
        },
        {
          value: 3,
          label: this.label.get('employee')
        }
        ],
        departmentEnabled: this.$store.state.companySettings.enable_departments,
        departments: this.getDepartmentsList(),
         resendButtonDisabled: false,
         deleteItem: false,
         itemId: null,
         itemType: null,
       }
    },
    created() {
      this.getInvite();
    },
    computed: {
      department() {
        if(this.invite) {
          return this.invite.department_id ? this.invite.department_id : -1;
        }
        return -1;
      }
    },
    mounted() {
      this.$root.$on('hideDeleteMember', this.hideDeleteMember);
    },
    beforeDestroy() {
      this.$root.$off('hideDeleteMember');
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getDepartmentsList() {
        let departments = this.$store.state.companyDepartments.map(item => {
          return {
            value: item.id,
            label: item.name
          };
        });
        departments.unshift({
          value: -1,
          label: this.label.get('no_department')
        });

        return departments;
      },
      getInvite() {
        const id = this.$route.params.id;
        this.$store.commit('showLoading');
        InviteService.getInviteById(id).then((result) => {
          this.invite = result;
          this.$store.commit('hideLoading');
        }).catch((error) => {
          this.$store.commit('hideLoading');
        });
      },
      onRoleChanged(option) {
        debugger;
        if(this.invite.role_id !== option.value) {
          InviteService.assignInviteRole({
            invite_id: this.invite.id,
            role_id: option.value
          }).then((response) => {
            this.invite.role_id = option.value;
            this.$awn.success(response.data.message);
          }).catch((error) => {
            debugger;
          });
        }
      },
      onDepartmentChanged(option) {
        debugger;
        if(this.invite.department_id !== option.value) {
          if(option.value > 0) {
            InviteService.addInviteToDepartment({
              invite_id: this.invite.id,
              department_id: option.value
            }).then((response) => {
              this.invite.department_id = option.value;
              this.$awn.success(response.data.message);
            }).catch((error) => {
              console.log(error);
            });
          } else if (option.value === -1) {
            InviteService.deleteInviteFromDepartment({
              user_id: this.invite.id
            }).then((response) => {
              this.invite.department_id = null;
              this.$awn.success(response.data.message);
            }).catch((error) => {
              console.log(error);
            });
          }
        }
      },
      resendInvite() {
        this.resendButtonDisabled = true;
        InviteService.resendInvites({ invite_id: this.invite.id }).then((result) => {
          this.resendButtonDisabled = false;
          this.$awn.success(result.data.message);
        }).catch((error) => {
          this.resendButtonDisabled = false;
          this.$awn.alert(error.message)
        })
      },
      deleteInvite(invite) {
        this.itemType = 'invite';
        this.itemId = invite.id;
        this.deleteItem = true;
      },
      hideDeleteMember(data) {
        if(data) {
          this.$router.push({ path: '/settings/manage-team'});
        }
        this.deleteItem = false;
        this.itemId = null;
        this.itemType = null;
      },
    }
  }
</script>

<style lang="scss" scoped>
.container-wrap{
  .container-header{
    padding: 10px 8px;
    justify-content: flex-start;
  }
}

.user-details .user-profile .profile-pic > i{
  font-size: 100px;
}
.invite-profile.invite-buttons {
  padding: 0 0 60px 180px;
  display: flex;
  align-self: flex-start;

  button{
    text-transform: uppercase !important;

    &.atto-btn.submit{
      text-transform: uppercase !important;
      margin-right: 40px;
    }
    &.deactivate{
      &:hover{
        background-color: #c24444;
      }
    }
  }
}



@media (max-width: 1270px) {
  .white-card{
    .user-details{
      flex-flow: column;
      .user-profile{
        .user-info{
          .info-field{
            flex-flow: column;
            justify-content: flex-start;
            align-items: flex-start;
            align-self: flex-start;
          }
          .separator-line{
            display: flex;
            align-self: flex-start;
          }
        }
      }
      .role-and-department{
        max-width: 410px;
        margin: 40px 0;
      }
    }
  }
  .invite-profile.invite-buttons {
   flex-flow: column;

    button.atto-btn.submit{
      margin: 0 0 25px 0;
    }
  }

}
</style>